export * from "./components/pagination";
export * from "./pagination.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/collections/pagination/index.js
// module id = 473
// module chunks = 0